/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Not_SetInputs */



/**
* | output |
* | --- |
* | "Not set" |
*
* @param {Compare_Event_Groups_Not_SetInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_not_set = /** @type {((inputs?: Compare_Event_Groups_Not_SetInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Not_SetInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Non défini")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nicht festgelegt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non impostato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не задано")
	if (locale === "es") return /** @type {LocalizedString} */ ("No establecido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("設定されていません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सेट नहीं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não definido")
	return /** @type {LocalizedString} */ ("Not set")
});